import IAsset from "../../../models/IAsset";

interface AudioAssetPreviewProps {
  asset: IAsset;
}

export default function AudioAssetPreview({ asset }: Readonly<AudioAssetPreviewProps>) {
  if (!asset) return null;
  return (
    <div>
      <audio controls src={`/api/Asset/${asset.blobPath}`}></audio>
      <div>{asset.name}</div>
    </div>
  );
}
